import { app } from '../env'

const BLOCKED_PROTOCOLS = ['javascript:', 'data:', 'vbscript:', 'blob:', 'file:', 'filesystem:']
const RELATIVE_URL_PROBE = 'https://relative.invalid/'

const parseRedirectUrl = (value: string | null | undefined): URL | undefined => {
  if (value === undefined || value === null || value.length === 0) {
    return undefined
  }
  try {
    const url = new URL(value)
    return !BLOCKED_PROTOCOLS.includes(url.protocol) && new URL(value, RELATIVE_URL_PROBE).href === url.href ? url : undefined
  } catch {
    return undefined
  }
}

const getAuthority = (url: URL): string => `${url.protocol}//${url.host}`

export const isValidRedirectUrl = (value: string | null | undefined): value is string => parseRedirectUrl(value) !== undefined

export const composeCallbackUrl = (baseUrl: string, relativeCallbackUrl: string): string | undefined => {
  const callbackUrl = baseUrl + relativeCallbackUrl
  const base = parseRedirectUrl(baseUrl)
  const callback = parseRedirectUrl(callbackUrl)
  return base !== undefined && callback !== undefined && getAuthority(callback) === getAuthority(base) ? callbackUrl : undefined
}

export const getFallbackRedirectUrl = (referrer: string | null | undefined, reportInvalid: (message: string) => void): string | undefined => {
  if (referrer !== undefined && referrer !== null && referrer.length > 0) {
    if (isValidRedirectUrl(referrer)) {
      return referrer
    }
    reportInvalid('Invalid checkout referrer URL')
  }
  if (isValidRedirectUrl(app.BROCHURE_BASE_URL)) {
    return app.BROCHURE_BASE_URL
  }
  reportInvalid('Invalid checkout brochure URL')
  return undefined
}
